// extracted by mini-css-extract-plugin
export default {"loadingIcon":"Button_loadingIcon__EGwbq","spin":"Button_spin__ikprI","button":"Button_button__EN0sy"};